import { CALL_API } from 'redux-api-middleware'
import { sessionService } from 'redux-react-session'
// import { push } from 'react-router-redux'
import {
  INFO_EP,
} from '../constant'
import {
  LOAD_INFO_SETTING_PAGES_REQUEST,
  LOAD_INFO_SETTING_PAGES_SUCCESS,
  LOAD_INFO_SETTING_PAGES_FAILURE,
  LOAD_ALL_INTERESTS_REQUEST,
  LOAD_ALL_INTERESTS_SUCCESS,
  LOAD_ALL_INTERESTS_FAILURE,
  UPDATE_INTERESTS_REQUEST,
  UPDATE_INTERESTS_SUCCESS,
  UPDATE_INTERESTS_FAILURE,
  UPDATE_PASSWORD_REQUEST,
  UPDATE_PASSWORD_SUCCESS,
  UPDATE_PASSWORD_FAILURE,
  UPDATE_INFO_REQUEST,
  UPDATE_INFO_SUCCESS,
  UPDATE_INFO_FAILURE,
  UPLOAD_USER_IMG_REQUEST,
  UPLOAD_USER_IMG_SUCCESS,
  UPLOAD_USER_IMG_FAILURE,
  CANCLE_ERROR,
  LOAD_EXAMHISTORY_REQUEST,
  LOAD_EXAMHISTORY_SUCCESS,
  LOAD_EXAMHISTORY_FAILURE,
  LOAD_EXAMPRODUCTHISTORY_REQUEST,
  LOAD_EXAMPRODUCTHISTORY_SUCCESS,
  LOAD_EXAMPRODUCTHISTORY_FAILURE,

} from './types'
import { token } from '../utils'
const headers = {
  'x-session-token': token,
  'server-name': 'deknerd',
}
// function checkResponse (response) {
//   if (response === 'authentication error') {
//     sessionService.deleteSession()
//     sessionService.deleteUser()
//     return false
//     // // window.location = 'http://localhost:3000/'
//     // return (dispatch) => {
//     //   dispatch(push('/'))
//   }

//     // window.location.place('/')
//     // window.location.href = '/'
//     // this.forceUpdate()
//     // window.location.href = '/'
//     // push('/')
//   return true
// }
export const loadInfoPages = (endpoint) => {
  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint,
        method: 'GET',
        headers,
        types: [LOAD_INFO_SETTING_PAGES_REQUEST,
          // {
          //   type: LOAD_INFO_SETTING_PAGES_SUCCESS,
          //   payload: async (action, state, res) => {
          //     const response = await res.json()
          //     // await checkResponse(response) === false ? dispatch(push('/')) : ''
          //     // await checkResponse(response) === false ? window.location.reload() : ''
          //     return response
          //   },
          // },
          {
            type: LOAD_INFO_SETTING_PAGES_SUCCESS,
            payload: async (action, state, res) => {
              const response = await res.json()
              const { displayName, imageURL } = response
              await sessionService.saveUser({ displayName, imageURL })
              await response.myLibCourse !== null ? response.myLibCourse = response.myLibCourse.filter((course) => ( course.product.courses!== null)) : []
              await response.myLibExam !== null ? response.myLibExam = response.myLibExam.filter((exam) => ( exam.product.exams !== null)) : []
              // await response.myLibLivestream !== null ? 
              await response.myLibPackage !== null ? response.myLibPackage = response.myLibPackage.filter((packages) => ( packages.product.products !== null)) : []
              return response
            },
          },
          {
            type: LOAD_INFO_SETTING_PAGES_FAILURE,
            payload: async (action, state, res) => {
              const response = await res.json()
              await sessionService.deleteSession()
              await sessionService.deleteUser()
              // await dispatch(push('/'))
              // await window.location.replace('/')
              return response
            },
            // LOAD_INFO_SETTING_PAGES_FAILURE
          }],
      },
    })
  }
}

export const loadInterest = endpoint => ({
  [CALL_API]: {
    endpoint,
    method: 'GET',
    headers,
    types: [LOAD_ALL_INTERESTS_REQUEST, LOAD_ALL_INTERESTS_SUCCESS, LOAD_ALL_INTERESTS_FAILURE],
  },
})

export const onSaveInfo = (endpoint, dataForm) => {
  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint,
        method: 'PUT',
        body: JSON.stringify(dataForm),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'x-session-token': token,
          'server-name': 'deknerd',
        },
        types: [UPDATE_INFO_REQUEST,
          {
            type: UPDATE_INFO_SUCCESS,
            payload: async (action, state, res) => {
              const response = await res.json()
              await dispatch(loadInfoPages(INFO_EP))
              // await dispatch(setTimeout(window.location.replace('/setting'), 3000))
              // await setTimeout(() => { window.location.replace('/setting') }, 3000)
              // const { displayName, imageURL } = response
              // await sessionService.saveUser({ displayName, imageURL })
              return response
            },
          }, UPDATE_INFO_FAILURE],
      },
    })
  }
}

export const uploadImage = (endpoint, img) => {
  const formData = new FormData(img)
  formData.append('sampleFile', img)
  formData.append('name', img.name)
  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint,
        method: 'POST',
        body: formData,
        headers,
        types: [UPLOAD_USER_IMG_REQUEST, UPLOAD_USER_IMG_SUCCESS, UPLOAD_USER_IMG_FAILURE],
      },
    })
  }
}

export const onSavePassword = (endpoint, passwordForm) => {
  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint,
        method: 'POST',
        body: JSON.stringify(passwordForm),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'x-session-token': token,
          'server-name': 'deknerd',
        },
        types: [UPDATE_PASSWORD_REQUEST, UPDATE_PASSWORD_SUCCESS, UPDATE_PASSWORD_FAILURE],
      },
    })
  }
}

export const cancleError = () => ({
  type: CANCLE_ERROR,
})

export const updateInterest = endpoint => ({
  [CALL_API]: {
    endpoint,
    method: 'PUT',
    headers,
    types: [UPDATE_INTERESTS_REQUEST, UPDATE_INTERESTS_SUCCESS, UPDATE_INTERESTS_FAILURE],
  },
})
export const loadExamHistory = endpoint => ({
  [CALL_API]: {
    endpoint,
    method: 'GET',
    headers,
    types: [LOAD_EXAMHISTORY_REQUEST, LOAD_EXAMHISTORY_SUCCESS, LOAD_EXAMHISTORY_FAILURE],
  },
})
export const loadExamProductHistory = endpoint => ({
  [CALL_API]: {
    endpoint,
    method: 'GET',
    headers,
    types: [LOAD_EXAMPRODUCTHISTORY_REQUEST, LOAD_EXAMPRODUCTHISTORY_SUCCESS, LOAD_EXAMPRODUCTHISTORY_FAILURE],
  },
})




// WEBPACK FOOTER //
// ./src/actions/setting.js